import { useEffect, useState } from "react";
import {
  removeGalleryImage,
  subscribeToGallery,
  updateGalleryImage,
  uploadGalleryImage,
} from "../../services/galleryService";

const initialFormState = {
  titleHindi: "",
  titleEnglish: "",
  featured: false,
  file: null,
};

const GalleryManager = () => {
  const [images, setImages] = useState([]);
  const [formState, setFormState] = useState(initialFormState);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const unsubscribe = subscribeToGallery((items) => setImages(items));
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked, files } = event.target;
    if (type === "file") {
      setFormState((prev) => ({ ...prev, file: files ? files[0] : null }));
    } else if (type === "checkbox") {
      setFormState((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formState.file) {
      setMessage("कृपया चित्र चुनें। / Please select an image.");
      return;
    }
    setUploading(true);
    setMessage("");
    try {
      await uploadGalleryImage(formState);
      setFormState(initialFormState);
      event.target.reset();
      setMessage("चित्र सफलतापूर्वक जोड़ा गया। / Image uploaded successfully.");
    } catch (error) {
      setMessage(`त्रुटि: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  const toggleVisibility = async (image) => {
    await updateGalleryImage(image.id, { visible: !(image.visible !== false) });
  };

  const toggleFeatured = async (image) => {
    await updateGalleryImage(image.id, { featured: !image.featured });
  };

  const deleteImage = async (image) => {
    if (
      window.confirm("क्या आप चित्र मिटाना चाहते हैं? / Delete this image?")
    ) {
      await removeGalleryImage(image.id, image.storagePath);
    }
  };

  return (
    <section className="admin-section">
      <header>
        <h3>चित्र प्रबंधन</h3>
        <span className="caption">Gallery Management</span>
      </header>
      <form onSubmit={handleSubmit} className="admin-form">
        <label htmlFor="gallery-title-hi">
          शीर्षक (हिंदी)
          <span className="caption">Title (Hindi)</span>
        </label>
        <input
          id="gallery-title-hi"
          name="titleHindi"
          value={formState.titleHindi}
          onChange={handleInputChange}
        />
        <label htmlFor="gallery-title-en">
          शीर्षक (अंग्रेज़ी)
          <span className="caption">Title (English)</span>
        </label>
        <input
          id="gallery-title-en"
          name="titleEnglish"
          value={formState.titleEnglish}
          onChange={handleInputChange}
        />
        <label htmlFor="gallery-file">
          चित्र चयन
          <span className="caption">Select Image</span>
        </label>
        <input
          id="gallery-file"
          type="file"
          accept="image/*"
          onChange={handleInputChange}
        />
        <label htmlFor="gallery-featured" className="checkbox-inline">
          <input
            id="gallery-featured"
            name="featured"
            type="checkbox"
            checked={formState.featured}
            onChange={handleInputChange}
          />
          विशेष आकर्षण
          <span className="caption">Feature on carousel</span>
        </label>
        <button type="submit" disabled={uploading}>
          अपलोड
          <span className="caption">Upload</span>
        </button>
        {message && <p className="form-message">{message}</p>}
      </form>

      <div className="admin-table">
        <h4>चित्र सूची</h4>
        <span className="caption">Image List</span>
        <table>
          <thead>
            <tr>
              <th>
                पूर्वावलोकन
                <br />
                <span className="caption">Preview</span>
              </th>
              <th>
                शीर्षक
                <br />
                <span className="caption">Title</span>
              </th>
              <th>
                स्थिति
                <br />
                <span className="caption">Status</span>
              </th>
              <th>
                क्रिया
                <br />
                <span className="caption">Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {images.map((image) => (
              <tr key={image.id}>
                <td>
                  <img
                    src={image.downloadUrl}
                    alt={image.titleEnglish || "Gallery"}
                    className="table-thumb"
                  />
                </td>
                <td>
                  <strong>{image.titleHindi}</strong>
                  <div className="caption">{image.titleEnglish}</div>
                </td>
                <td>
                  <div>{image.visible !== false ? "दृश्य" : "गोपित"}</div>
                  <div className="caption">
                    {image.featured ? "Featured" : "Regular"}
                  </div>
                </td>
                <td className="table-actions">
                  <button type="button" onClick={() => toggleVisibility(image)}>
                    {image.visible !== false ? "छिपाएँ" : "दर्शाएँ"}
                    <span className="caption">
                      {image.visible !== false ? "Hide" : "Show"}
                    </span>
                  </button>
                  <button type="button" onClick={() => toggleFeatured(image)}>
                    {image.featured ? "सामान्य" : "विशेष"}
                    <span className="caption">
                      {image.featured ? "Unfeature" : "Feature"}
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => deleteImage(image)}
                    className="danger"
                  >
                    हटाएँ
                    <span className="caption">Delete</span>
                  </button>
                </td>
              </tr>
            ))}
            {images.length === 0 && (
              <tr>
                <td colSpan={4}>कोई चित्र उपलब्ध नहीं है।</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default GalleryManager;
